import React from 'react';
import Carousel from '../../shared/Carousel';
import LoadingDestinationCard from '../Cards/LoadingDestinationCard';

export default function DestinationCarouselPlaceholder({
    breakpoints,
    cardSizeSm,
    scrolling,
    placeholdersQuantity = 8,
}) {
    const placeholdersArray = Array.from(
        {length: placeholdersQuantity},
        (item, index) => index + 1
    );
    const placeholders = placeholdersArray.map((value) => (
        <LoadingDestinationCard
            key={value}
            data-testid="loading-destination-card"
            cardSizeSm={cardSizeSm}
        />
    ));

    return (
        <Carousel
            breakpoints={breakpoints}
            cardSizeSm={cardSizeSm}
            cards={placeholders}
            scrolling={scrolling}
        />
    );
}
